import searchSvg from '@/assets/icons/search.svg'
// import ShareSvg from '@/assets/icons/share.svg?react'
import style from '@/views/Stores/StoreFront.module.scss'

interface StoreUtilityRowProps {
  hasActiveSearch: boolean
  defaultValue: string
  onSearch: (searchTerm: string) => void
  onClear: () => void
  onShare: () => void
}

export default function StoreUtilityRow({
  hasActiveSearch,
  defaultValue,
  onSearch,
  onClear,
  // onShare,
}: StoreUtilityRowProps) {
  const [inputValue, setInputValue] = useState(defaultValue)

  const shouldShowClearButton = inputValue.trim() || hasActiveSearch

  return (
    <div className={style.UtilityRowContainer}>
      <div className={style.UtilityRow} aria-label='Store utilities'>
        <form
          role='search'
          className={style.SearchWrapper}
          onSubmit={e => {
            e.preventDefault()
            const trimmedTerm = (
              Object.fromEntries(new FormData(e.currentTarget)).search as string
            ).trim()
            if (trimmedTerm === '') {
              onClear()
            } else {
              onSearch(trimmedTerm)
            }
          }}
        >
          <input
            type='search'
            name='search'
            className={style.StoreSearch}
            placeholder='Search'
            aria-label='Search within store'
            id='main-content'
            defaultValue={defaultValue}
            value={inputValue}
            onChange={e => {
              setInputValue(e.target.value)
            }}
          />
          {shouldShowClearButton && (
            <button
              type='button'
              className={`${style.SearchBtn} ${style.ClearBtn}`}
              onClick={() => {
                setInputValue('')
                onClear()
              }}
              aria-label='Clear search'
            >
              ×
            </button>
          )}
          <button type='submit' className={style.SearchBtn} aria-label='Filter Search Results'>
            <img src={searchSvg} alt='' />
          </button>
        </form>
        {/* <button type='button' className={style.ShareBtn} onClick={onShare} aria-label='Share'>
          <ShareSvg aria-hidden />
          <span>Share</span>
        </button> */}
      </div>
    </div>
  )
}
